<div class="orcamentos-page">
  <div class="page-header">
    <h4>Orçamentos da Consulta</h4>
    <div class="header-actions">
      <button type="button" class="btn btn-outline-secondary me-2" (click)="voltar()">
        <i class="fa fa-arrow-left"></i> Voltar
      </button>
      <a
        class="btn btn-primary"
        [routerLink]="['/novo-orcamento-consulta']"
        [queryParams]="{ idConsulta: idConsulta }">
        <i class="fa fa-plus"></i> Novo Orçamento
      </a>
    </div>
  </div>

  <div class="card-box">
    <div *ngIf="loading" class="text-muted">Carregando orçamentos...</div>

    <div class="table-responsive" *ngIf="!loading">
      <table class="table table-hover mb-0">
        <thead>
          <tr>
            <th style="width: 80px;">#</th>
            <th>Título</th>
            <th style="width: 140px;">Data</th>
            <th>Observação</th>
            <th style="width: 360px;">Ações</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of orcamentos; let i = index">
            <td>{{ i + 1 }}</td>
            <td>{{ item.titulo || '-' }}</td>
            <td>{{ item.data | date:'dd/MM/yyyy' }}</td>
            <td>{{ item.observacao || '-' }}</td>
            <td>
              <a
                class="btn btn-sm btn-primary me-2"
                [routerLink]="['/novo-orcamento-consulta']"
                [queryParams]="{ idConsulta: (item.idConsulta || idConsulta) }">
                <i class="fa fa-plus"></i> Novo
              </a>
              <button type="button" class="btn btn-sm btn-info me-2" (click)="visualizar(item)">
                <i class="fa fa-eye"></i> Visualizar
              </button>
              <button type="button" class="btn btn-sm btn-secondary me-2" (click)="imprimir(item)">
                <i class="fa fa-print"></i> Imprimir
              </button>
              <button type="button" class="btn btn-sm btn-danger" (click)="excluir(item)">
                <i class="fa fa-trash"></i> Excluir
              </button>
            </td>
          </tr>
          <tr *ngIf="orcamentos.length === 0">
            <td colspan="5" class="text-center text-muted py-3">Nenhum orçamento encontrado.</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
